module.exports = __webpack_public_path__ + "static/media/hs-orange.cd590991.jpg";